import { ADD_ORDER_PAYMENT_CARD } from 'redux/modules/payment/actions/types';

const reducer = state => ({
  ...state,
  currentApiRequest: ADD_ORDER_PAYMENT_CARD.request,
  requireCardAuth: false,
});

export default reducer;
